
import TopNav from '~/layouts/partials/TopNav';
import AppFooter from '~/layouts/partials/AppFooter';
import Crumbs from '~/layouts/partials/Crumbs';

export default {
  components: {Crumbs, AppFooter, TopNav},
};
